module.exports = __webpack_public_path__ + "media/site_templates/www.cheaptaxaccountants.com.au/images/splash-18e17c0df8a13bb02c9235cc79fcce43.jpg";